<template>
    <vs-popup :title="id ? 'アドレス帳編集' : 'アドレス帳新規登録'" :active.sync="statusModelContactDetail" button-close-hidden>
        <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full">
                <label class="text-sm opacity-75">名前</label><span style="color: red">*</span>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
                <vs-input class="w-full" v-model="name" @input="nameChange" id="name"/>
                <span v-show="nameError" class="mb-2 text-danger font-size-info" style="display: block;">{{ nameErrorContent }}</span>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col sm:w-1/4 w-full">
            <label class="text-sm opacity-75">メールアドレス</label><span style="color: red">*</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <vs-input class="w-full" v-model="mail_address" @input="mailAddressChange" id="mail_address"/>
            <span v-show="mailAddressError" class="mb-2 text-danger font-size-info" style="display: block;">{{ mailAddressErrorContent }}</span>
          </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full flex justify-center">
                <vs-button @click="store" color="success"  style="width: 100px; padding: 8px; margin-right: 5px;margin-left: 10px;height: 37px">{{ id ? '変更する' : '新規登録' }}</vs-button>
                <vs-button @click="cancel" color="lightgrey" icon="cancel" style="width: 100px; padding: 8px; margin-right: 5px;margin-left: 10px;height: 37px">戻る</vs-button>
            </div>
        </div>
    </vs-popup>
</template>
  
<script>
import { mapActions } from 'vuex'
import EventBus from "../EventBus";
export default {
    props: {
        activeModelContactDetail: {
            required: true,
            type: Boolean,
        },
        contactShow: {
            type: Object,
            default: {}
        },
        typeModalContact: {
            type: String,
        },
    },
    data() {
        return {
            id: null,
            name: "",
            mail_address: "",
            statusModelContactDetail: false,
            nameError: false,
            nameErrorContent: '',
            mailAddressError: false,
            mailAddressErrorContent: ''
        }
    },
    methods: {
        ...mapActions({
            createContact: 'contact/create',
            updateContact: 'contact/update',
        }),
        nameChange() {
            this.nameError = false
            this.nameErrorContent = ''
            if(this.name == ""){
                this.nameError = true
                this.nameErrorContent = '名前は必須です。'
            } else if(this.name.length > 256) {
                this.nameError = true
                this.nameErrorContent = '名称は、256文字以下で指定してください。'
            }
        },
        mailAddressChange() {
            this.mailAddressError = false
            this.mailAddressErrorContent = ''
            if(this.mail_address == '') {
                this.mailAddressError = true
                this.mailAddressErrorContent = 'メールアドレスは必須です。'
            } else if(!this.validateEmail(this.mail_address)) {
                this.mailAddressError = true
                this.mailAddressErrorContent = 'メールアドレスの形式が正しくありません。'
            } else if(this.mail_address.length > 256) {
                this.mailAddressError = true
                this.mailAddressErrorContent = 'mail addressは、256文字以下で指定してください。'
            }
        },
        setValidate() {
            this.nameError = false
            this.nameErrorContent = ''
            this.mailAddressError = false
            this.mailAddressErrorContent = ''
        },
        validateForm() {
            this.nameChange()
            this.mailAddressChange()
        },
        validateEmail(email) {
            if (email.length > 0) {
                email = email.trim()
            }
            let success = true;
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(email).toLowerCase())) {
                success = false;
            }
            return success;
        },
        async store() {
            this.validateForm()
            if(!this.nameError && !this.mailAddressError) {
                let data = {
                    id: this.id,
                    name: this.name,
                    mail_address: this.mail_address,
                }
                if(this.id) {
                    try {
                        await this.updateContact(data);
                        this.onCloseContactDetailModal();
                    } catch (error) {
                        console.log('updateContact Failed', error);
                    }
                   
                } else {
                    try {
                        await this.createContact(data)
                        this.onCloseContactDetailModal();
                    } catch (error) {
                        console.log('createContact Failed', error);
                    }
                }
            }
        },
        onCloseContactDetailModal() {
            this.statusModelContactDetail = false
            this.$emit('cancelPopupContactDetail', true,this.typeModalContact)
        },
        cancel() {
            this.statusModelContactDetail = false
            this.$emit('cancelPopupContactDetail', false, this.typeModalContact)
            EventBus.$emit('contactShowObjectEmpty')
        }
    },
    watch: {
        contactShow(obj) {
            this.id = obj.id ? obj.id : null,
            this.name = obj.name ? obj.name : "",
            this.mail_address = obj.mail_address ? obj.mail_address : ""
            this.setValidate();
        },
        activeModelContactDetail() {
            this.$nextTick(() => {
                this.statusModelContactDetail = this.activeModelContactDetail
            });
        },
        statusModelContactDetail(val) {
            this.$nextTick(() => {
                if(val == false) {
                    EventBus.$emit('disableModelContactDetail')
                    EventBus.$emit('contactShowObjectEmpty')
                }
            });
        } 
    }
}
</script>